export const systemSettingsMenuDef = [
    {
        name: 'ConstantValueSet',
        resource: 'constantValueSet',
        icon: 'fa fa-user',
        url: 'constantValueSet',
        auto_crud: true,
        breadcrumb: 'Constant Value Set'
    },
    {
        name: 'Language',
        resource: 'language',
        icon: 'fa fa-tag',
        url: 'language',
        auto_crud: true
    },
   
    {
        name: 'TimeZone',
        resource: 'timezone',
        icon: 'fa fa-tag',
        url: 'timezone',
        auto_crud: true
    },
    {
        name: 'Payer Management',
        icon: 'fa fa-building-o',
        data:{
            nav_url: "payer_group_m"
        },
        children: [

            {
                name: 'Payer Group',
                icon: 'fa fa-user',
                resource: 'payer_group',
                url: 'payer_group',
                auto_crud: true,
                breadcrumb: 'Payer Group'
            },
            {
                name: 'Payer Sub Group',
                icon: 'fa fa-user',
                resource: 'payer_sub_group',
                url: 'payer_sub_group',
                auto_crud: true,
                breadcrumb: 'Payer Sub Group'
            },
            {
                name: 'Payer Master',
                icon: 'fa fa-user',
                resource: 'payer',
                url: 'payer',
                auto_crud: true,
                breadcrumb: 'Payer Master'
            }
        ]
    },
    {
        name: 'Sponsor',
        resource: 'sponsor',
        icon: 'fa fa-user',
        url: 'sponsor',
        auto_crud: true
    },
    {
        name: 'Tariff',
        resource: 'tariff',
        icon: 'fa fa-tag',
        url: 'tariff',
        auto_crud: true
    },
    {
        name: 'Package',
        resource: 'package_detail',
        icon: 'fa fa-tag',
        url: 'package_detail',
        auto_crud: true
    },
    {
        name: 'organization Setup',
        icon: 'fa fa-tags',
        data:{
            nav_url: "organizationSetup_paymentType_m"
        },
        children: [
            {
                name: 'Payment Type',
                resource: 'organizationSetup_paymentType',
                icon: 'fa fa-tag',
                url: 'organizationSetup_paymentType',
                auto_crud: true

            },
            {
                name: 'Bank Master',
                resource: 'organizationSetup_bankMaster',
                icon: 'fa fa-tag',
                url: 'organizationSetup_bankMaster',
                auto_crud: true
            },
            {
                name: 'Service Type',
                resource: 'organizationSetup_serviceType',
                icon: 'fa fa-tag',
                url: 'organizationSetup_serviceType',
                auto_crud: true

            },
            {
                name: 'Service Priority',
                resource: 'servicePriority',
                icon: 'fa fa-tag',
                url: 'servicePriority',
                auto_crud: true
            },
            {
                name: 'Billing Category',
                resource: 'billingCategory',
                icon: 'fa fa-tag',
                url: 'billingCategory',
                auto_crud: true
            },
            {
                name: 'menu.audit_diff_config',
                resource: 'audit_diff_config',
                icon: 'fa fa-file-text-o',
                url: 'audit_diff_config',
                auto_crud: true,
                breadcrumb: 'audit_diff_config'
            }
        ]
    }

]    
